"use client";

import VenueShowsCalendar, {
  type VenueShowsCalendarProps,
} from "./VenueShowsCalendar";
import { useVenuePageTheme } from "../../hooks";

interface VenueShowsCalendarThemedProps extends VenueShowsCalendarProps {
  venueSlug: string;
}

export default function VenueShowsCalendarThemed({
  venueSlug,
  ...rest
}: VenueShowsCalendarThemedProps) {
  const {
    accentColor,
    headerTextColor,
    headerBorderColor,
    headerBackgroundColor,
  } = useVenuePageTheme(venueSlug);

  return (
    <VenueShowsCalendar
      {...rest}
      venueSlug={venueSlug}
      // append the theme values for this venue
      theme={{
        accentColor,
        headerTextColor,
        headerBorderColor,
        headerBackgroundColor,
      }}
    />
  );
}
